<template>
    <div class="overall-statistics">
        <div class="media projects">
            <i class="fas fa-folder-tree align-self-center media-icon"></i>
            <div class="media-body">
                <h5 class=" media-title">{{$t('statistics.projects')}}</h5>
                <div class="media-content">{{ numberOfGroupsIn }}</div>
            </div>
        </div>

        <div class="media teachers">
            <i class="fas fa-chalkboard-teacher align-self-center media-icon"></i>
            <div class="media-body">
                <h5 class=" media-title">{{$t('statistics.teachers')}}</h5>
                <div class="media-content">{{ numberOfTeachersIn }}</div>
            </div>
        </div>

        <div class="media students">
            <i class="fas fa-graduation-cap align-self-center media-icon"></i>
            <div class="media-body">
                <h5 class=" media-title">{{$t('statistics.students')}}</h5>
                <div class="media-content">{{ numberOfStudentsIn }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-statistics-index-overall-statistics-component",
    props: [
        'numberOfGroupsIn',
        'numberOfTeachersIn',
        'numberOfStudentsIn'
    ]
}
</script>

<style scoped>
    .overall-statistics {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 30px;
    }

    .media{
        flex: 1;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
    }

    .projects {
        background-color: rgba(0, 123, 255, 0.2);
    }

    .teachers {
        background-color: rgba(255, 181, 72, 0.2);
    }

    .students {
        background-color: rgba(10, 207, 151, 0.2);
        margin-bottom: 0;
    }

    .media-icon {
        font-size: 2.75rem;
        margin-right: 30px;
        margin-left: 15px;
    }

    .projects .media-icon {
        color: #007bff;
    }

    .teachers .media-icon {
        color: #FFB548;
    }

    .students .media-icon {
        color: #0ACF97;
    }

    .media-title {
        font-size: 1.25rem;
        font-weight: normal;
        line-height: 1.1;
        margin: 0;
    }

    .media-content {
        font-size: 2.5rem;
        font-weight: 500;
    }

    @media (min-width: 768px) {
        .overall-statistics {
            flex-direction: row;
            justify-content: space-between;
        }

        .media {
            margin-bottom: 0;
        }

        .teachers {
            margin: 0 30px;
        }
    }
</style>
